export default __webpack_public_path__ + "static/media/icon-verified-mark.3b4879d8.svg";